<template>
    <div class="component-navbar">
        <b-navbar toggleable="md" type="dark" variant="info" class="main-nav">
            <b-navbar-brand href="/">Howrly</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav >

                <b-navbar-nav class="ml-auto"> <!-- ml-auto forces items to be center aligned -->
                    <b-nav-item :active="'budget' === $route.name.split('-')[0]" :to="{name: 'budget-tasks'}"><font-awesome-icon icon="clock" /> Budget</b-nav-item>
                    <b-nav-item :active="'performance' === $route.name.split('-')[0]" :to="{name: 'performance-workforce'}"><font-awesome-icon icon="chart-area" /> Performance</b-nav-item>
                    <b-nav-item :active="'cost' === $route.name.split('-')[0]" :to="{name: 'cost-analytics'}"><font-awesome-icon icon="file-invoice-dollar" /> Cost</b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item :active="'settings' === $route.name.split('-')[0]" :to="{name: 'settings-overview'}" right><font-awesome-icon icon="cog" /></b-nav-item>

                    <b-nav-item-dropdown right>
                        <!-- Using 'button-content' slot -->
                        <template slot="button-content"><em><font-awesome-icon icon="user"/></em></template>
                        <b-dropdown-text style="width: 300px;" v-if="isAuthenticated()">Logged in as {{$auth.getUsername() | formatVariableName}}</b-dropdown-text>
                        <b-dropdown-text style="width: 300px;" v-if="isAuthenticated()">Organisation: {{$store.state.general.orgName}}</b-dropdown-text>
                        <b-dropdown-divider v-if="isAuthenticated()"></b-dropdown-divider>
                        <b-dropdown-item v-if="!isAuthenticated()" :to="{name: 'user-login'}">Login</b-dropdown-item>
                        <b-dropdown-item v-else @click="logout()">Logout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
            <!-- eslint-disable-next-line -->
            </router-view>
        </b-navbar>
    </div>
</template>

<script>

export default {
    name: 'navbar',
    data () {
        return {
        }
    },
    methods: {
        isAuthenticated () {
            return this.$auth.isAccessTokenValid()
        },
        logout () {
            this.$auth.logout()
            this.$router.push({ 'path': '/user/login' })
            // Force an update after logging out (needed for logout button to turn to login)
            // this.$forceUpdate()
            this.$router.go()
        }
    },
    created () {

    }
}
</script>

<style lang="scss">
.component-navbar {
    .main-nav {
        background: -webkit-linear-gradient(left, rgb(12, 68, 122) 15%, rgb(26, 110, 138) 55%, rgb(39, 149, 151) 90%);
        background: -o-linear-gradient(left, rgb(12, 68, 122) 15%, rgb(26, 110, 138) 55%, rgb(39, 149, 151) 90%);
        background: -ms-linear-gradient(left, rgb(12, 68, 122) 15%, rgb(26, 110, 138) 55%, rgb(39, 149, 151) 90%);
        background: -moz-linear-gradient(left, rgb(12, 68, 122) 15%, rgb(26, 110, 138) 55%, rgb(39, 149, 151) 90%);
        background: linear-gradient(to right, rgb(12, 68, 122) 15%, rgb(26, 110, 138) 55%, rgb(39, 149, 151) 90%);
        color: #fff;
    }
    a.nav-link {
        padding: 8px 20px !important;
        font-size: 18px !important;
    }
    .nav-link:active, .nav-link:hover, .nav-link:focus, .active {
        color: #fff !important;
    }
}
</style>
